define(function(require) {
    
    /**
     * static inclues
     *
     */
    var self = {}
    var $ = require('jquery')

    var navContainer= $('.scrollspy')
    var navItems    = $('.scrollspy a, .logo a')
    var navLast  = false
    var posSections  = { 
        'header'    : false,
        'neues'     : false,
        'wir'       : false,
        'kunden'    : false,
        'kontakt'   : false
    }
    var posNav
    var posOffset   = 200
    


    /**
     * public functions
     *
     */

    /* get position of nav */
    self.posNav = function(params) {
        posNav = navContainer.offset().top - $(window).scrollTop()
        return posNav
    }

    /* get positions of sections */
    self.posSections = function() {
        for(var key in posSections) {
            posSections[key] = $('#'+key).offset().top
        }
        // console.log(posSections)
        return posSections   
    }

    

    /* compare postions */
    self.posCompare = function(params) {
    
        self.posNav()
        self.posSections()

        // console.log(posSections)
        // console.log('posNav: ' + posNav + ', window.scrollY : ' + params)
        // console.log( $('#wir').offset().top- $(window).scrollTop() )

        if ( posSections['kontakt'] < (params + 700) ) {
            self.activateAnchor('kontakt')
        } 
        else if ( posSections['kunden'] < (params + posOffset) ) {
            self.activateAnchor('kunden')
        }
        else if ( posSections['wir'] < (params + posOffset) ) {
            self.activateAnchor('wir')
        }
        else if ( posSections['neues'] < (params + posOffset) ) {
            self.activateAnchor('neues')
        }
        else if ( posSections['header'] < (params + posOffset) ) {
            self.activateAnchor('header')
        }
    }

    /* activate Anchor */
    self.activateAnchor = function(params) {
        if ( !navLast  || !(navLast === params) ) {
            navLast = params;
            navItems.removeClass('active')
            navItems.closest( $('.'+params )).addClass('active')
            // history.pushState(null, null, '#'+params);
        } 
    }




    /* init */
    self.init = function(params) {
        self.posCompare(params)
    }



    

    /**
     * do stuff
     *
     */

    /* run once */
    return self


});
    

    












//////////////////
// WEBPACK FOOTER
// ./chunk/nav_scrollspy.js
// module id = 10
// module chunks = 0